/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type EventKindPlanningFreq = (typeof EventKindPlanningFreq)[keyof typeof EventKindPlanningFreq];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventKindPlanningFreq = {
  monthly: 'monthly',
  weekly: 'weekly',
} as const;
